import { render } from "./SecurityQuestion.vue?vue&type=template&id=69cd1952"
import script from "./SecurityQuestion.vue?vue&type=script&lang=js"
export * from "./SecurityQuestion.vue?vue&type=script&lang=js"

import "./SecurityQuestion.vue?vue&type=style&index=0&id=69cd1952&lang=css"
script.render = render

export default script